<template>
  <div class="histroy" :style="{height: innerHeight + 'px'}">
    <BackCurrent title="观看历史" v-if="appVersion === 'dd'" />
    <div class="container" id="histroyContainer">
      <template v-if="list && list.length > 0">
        <!-- <div class="subtitle">
          <span class="icon"></span>
          <p class="title">今天</p>
        </div> -->
        <div class="history-box" v-for="(item, index) in list" :key="index" @click="handleGoDetail(item.id)">
          <div class="box-top">
            <img class="avatar" :src="videoCdn + item.pic" />
            <div class="content">
              <p class="title p2-overflow">
                {{ item.name }}
              </p>
              <!-- <p class="last-time">最后观看 {{ item.time | format_Date_a }}</p> -->
            </div>
          </div>
          <div class="box-bottom">
            <span class="live-time">总计直播观看: {{ item.live_study_time | watch_record_format }}</span>
            <span class="record-time">总计点播观看：{{ item.record_study_time | watch_record_format }}</span>
          </div>
        </div>
      </template>

      <!-- <template v-if="yesterday && yesterday.length > 0">
        <div class="subtitle">
          <span class="icon"></span>
          <p class="title">昨天</p>
        </div>
        <div class="history-box" v-for="(item, index) in yesterday" :key="index" @click="handleGoDetail(item.id)">
          <div class="box-top">
            <img class="avatar" :src="videoCdn + item.pic" />
            <div class="content">
              <p class="title p2-overflow">
                {{ item.name }}
              </p>
              <p class="last-time">最后观看 {{ item.time | format_Date_b }}</p>
            </div>
          </div>
          <div class="box-bottom">
            <span class="live-time">总计直播观看: {{ item.live_study_time | watch_record_format }}</span>
            <span class="record-time">总计点播观看：{{ item.record_study_time | watch_record_format }}</span>
          </div>
        </div>
      </template>

      <template v-if="other && other.length > 0">
        <div class="subtitle">
          <span class="icon"></span>
          <p class="title">更久</p>
        </div>
        <div class="history-box" v-for="(item, index) in other" :key="index" @click="handleGoDetail(item.id)">
          <div class="box-top">
            <img class="avatar" :src="videoCdn + item.pic" />
            <div class="content">
              <p class="title p2-overflow">
                {{ item.name }}
              </p>
              <p class="last-time">最后观看 {{ item.time | format_Date_b }}</p>
            </div>
          </div>
          <div class="box-bottom">
            <span class="live-time">总计直播观看: {{ item.live_study_time | watch_record_format }}</span>
            <span class="record-time">总计点播观看：{{ item.record_study_time | watch_record_format }}</span>
          </div>
        </div>
      </template> -->
    </div>
  </div>
</template>

<script>
import BackCurrent from '@/components/back-current'
import {outHistory} from '@/api/dd'
import _ from 'lodash'
export default {
  name: 'histroy',
  components: {
    BackCurrent
  },
  data() {
    return {
      innerHeight: 0,
      list: [],
      // yesterday: [],
      // other: [],
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 20
      },
      histroyContainer: null
    }
  },
  methods: {
    initData() {
      outHistory(this.params).then(res => {
        if (res.code === 0 && res.success) {
          const data = res.data
          this.total = Math.ceil(Number(res.totalDatas) / this.params.pageSize)
          this.list = [...this.list, ...data]
          this.params.pageNo += 1
          // console.log('total', this.total, this.params.pageNo)
        }
      })
    },
    handleAddScroll() {
      this.histroyContainer = document.getElementById('histroyContainer')
      this.histroyContainer.addEventListener('scroll', _.debounce(this.onScroll.bind(this.histroyContainer), 500))
    },
    handleRemoveScroll() {
      this.histroyContainer.removeEventListener('scroll', _.debounce(this.onScroll.bind(this.histroyContainer), 500))
    },
    onScroll(e) {
      const target = e.target
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
        // console.log('到底了')
        if (this.total < this.params.pageNo) {
          this.$Toast.fail('已无更多数据')
        } else {
          this.initData()
        }
      }
      // console.log('el', target.scrollHeight, target.scrollTop, target.clientHeight)
    },
    handleGoDetail(id) {
      this.$router.push(`/customization/history-detail/${id}`)
    }
  },
  mounted() {
    this.innerHeight = window.innerHeight
    this.initData()
    this.handleAddScroll()
  },
  beforeDestroy() {
    this.handleRemoveScroll()
  }
}
</script>

<style lang="scss" scoped>
.histroy {
  width: 100%;

  p {
    margin: 0;
  }

  .container {
    width: 100%;
    height: calc(100% - 55px);
    padding: 16px 12px;
    box-sizing: border-box;
    overflow: scroll;

    .subtitle {
      display: flex;
      flex-direction: row;
      align-items: center;

      .icon {
        width: 4px;
        height: 15px;
        background-color: #4465f3;
        border-radius: 2px;
      }

      .title {
        margin-left: 4px;
        font-size: 15px;
        font-weight: 700;
        color: #000000;
      }
    }

    .history-box {
      width: 100%;
      /* margin-top: 18px; */
      margin-bottom: 18px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0px 0px 24px 0px rgba(23, 38, 71, 0.04);

      .box-top {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        padding: 16px 14px;
        box-sizing: border-box;
        flex: 0 0 132px;

        .avatar {
          width: 132px;
          height: 74px;
          border-radius: 6px;
        }

        .content {
          flex: 1;
          margin-left: 16px;

          .title {
            width: 165px;
            height: 44px;
            line-height: 22px;
            font-weight: 700;
            color: #303133;
            font-size: 14px;
          }

          .last-time {
            margin-top: 8px;
            font-size: 14px;
            color: #909399;
          }
        }
      }

      .box-bottom {
        width: 100%;
        border-top: 1px solid #e7e9ef;
        padding: 16px 14px;
        box-sizing: border-box;

        .live-time,
        .record-time {
          font-size: 13px;
          color: #909399;
        }

        .record-time {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
